import { Component, OnInit } from '@angular/core';
import { MessageDisplayUtil } from 'src/message-display-utils';
import { PlayerInfo } from 'src/data/player-data';
import { CourseInfo, CourseHoleInfo } from "src/data/club-course";
import { ClubFlightService } from "src/providers/club-flight-service/club-flight-service";
import { TeeTimeBooking } from "src/data/mygolf.data";
import { TeeTimeSlot, TeeTimeSlotDisplay, ClubCourseData, DiscountCompany, PlayerData, DiscountCompanyProgram } from 'src/data/mygolf.data';
import { ModalController, NavParams, Platform, ToastController } from '@ionic/angular';
import * as moment from 'moment';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';
import { ImageZoomPage } from '../../image-zoom/image-zoom.page';


@Component({
    selector: 'app-search-discount-company',
    templateUrl: './search-discount-company.page.html',
    styleUrls: ['./search-discount-company.page.scss'],
})
export class SearchDiscountCompanyPage implements OnInit {
    courses: Array<CourseInfo>;
    clubId: number;
    forDate: string;
    isClub: boolean = false;
    courseId: number;
    teeSlot: Array<TeeTimeSlotDisplay>;
    startCourses: Array<ClubCourseData>;
    changeType: string;
    currentSlot: TeeTimeBooking;
    color: string;
    currentTime: string;
    mode: string;
    type: string;
    optionTypes: string = 'types';
    headerTitle: string;
    playerTypes: Array<any>;
    discountCards: Array<any>;
    discountCompanies: Array<DiscountCompany>;
    selectedDiscountCompany: DiscountCompany;
    cardMembershipNo: string;
    discountPrograms: Array<DiscountCompanyProgram>;
    selectedDiscountProgram: DiscountCompanyProgram;

    cardValidFrom: string;
    cardValidUntil: string;
    player: PlayerData | PlayerInfo;
    searchCompany: string;
    refresher: boolean;
    partnerType: string = 'discount';
    countryId: string;
    constructor(
        private flightService: ClubFlightService,
        private navParams: NavParams,
        private toastCtl: ToastController,
        private modalCtrl: ModalController,
        private platform: Platform,
        private mg2uUtil: mygolfUtils) {
        this.courses = navParams.get("courses");
        this.clubId = navParams.get("clubId");
        this.forDate = navParams.get("forDate");
        this.courseId = navParams.get("courseId");
        this.changeType = navParams.get("changeType");
        this.currentSlot = navParams.get("currentSlot")
        if (this.changeType && this.changeType === 'slot') this.isClub = false;
        else if (this.changeType && this.changeType === 'course') this.isClub = true;
        this.mode = navParams.get("mode");
        this.type = navParams.get("type");
        this.headerTitle = navParams.get("headerTitle");
        this.player = navParams.get("player");

        this.partnerType = navParams.get("partnerType");
        this.countryId = navParams.get("countryId")
        this.playerTypes = [
            {
                id: "ARMY",
                name: "Armed Forces",
                use: true,
            },
            {
                id: "GOVT",
                name: "Government",
                use: true,
            },
            {
                id: "GUEST",
                name: "Member's Guest",
                use: false,
            },
            {
                id: "JUNIOR",
                name: "Junior",
                use: true,
            },
            {
                id: "MEMBER",
                name: "Club Member",
                use: true,
            },
            {
                id: "POLICE",
                name: "Police",
                use: true,
            },
            {
                id: "SENIOR",
                name: "Senior Citizen",
                use: true,
            },
            {
                id: "STAFF",
                name: "Staff",
                use: true,
            }, {
                id: "TMEMBER",
                name: "Term Member",
                use: true,
            },]
        this.playerTypes.sort((a, b) => {
            if (a.name < b.name) return -1
            else if (a.name > b.name) return 1
            else return 0
        });

        this.discountCards = [{
            id: "AGSSG 1",
            name: "Staff",
            use: true,
        }, {
            id: "AGSSG 2",
            name: "Term Member",
            use: true,
        },];

        this.cardValidFrom = moment().format("YYYY-MM-DD");
        this.cardValidUntil = moment().format("YYYY-MM-DD");

    }

    ngOnInit() {
        if (this.partnerType === 'insurance')
            this.goSearchInsuranceCompany();
        else if (this.partnerType === 'discount')
            this.onSearchCompanyClick();
        else this.onSearchCompanyClick();
    }


    close() {
        this.modalCtrl.dismiss();
    }
    onSelectThis(discountCompany: DiscountCompany) {
        // let _discComp = discountCompany;
        // if (!_discComp) return false;
        // let _companyId = discountCompany.id;
        // this.flightService.getDiscountPrograms(_companyId)
        //     .subscribe((data: any) => {

        //         if (data) {
        //             this.discountPrograms = data;
        //             if (data && data.length === 0) {
        //                 MessageDisplayUtil.showMessageToast('There is no program under this company. Please choose different company',
        //                     this.platform, this.toastCtl, 3000, "bottom");
        //                 return false;
        //             } else this.goSelectThis(discountCompany);
        //         } else {
        //             MessageDisplayUtil.showMessageToast('There is no program under this company. Please choose different company',
        //                 this.platform, this.toastCtl, 3000, "bottom");
        //             return false;
        //         }
        //     })
        let _discComp = discountCompany;
        if (!discountCompany) return;
        if (!_discComp) return false;
        let _companyId = discountCompany.id;
        let _partnerServices;
        if (discountCompany.partnerServices)
            _partnerServices = discountCompany.partnerServices.filter((service) => {
                return service.includes('INSURANCE') || service.includes('BOOKING_AGENT') || service.includes('OTHER')
            })
        if (_partnerServices && _partnerServices.length > 0)
            this.goSelectThis(discountCompany);
        else {
            this.flightService.getDiscountPrograms(_companyId)
                .subscribe((data: any) => {

                    if (data) {
                        this.discountPrograms = data;
                        if (data && data.length === 0) {
                            MessageDisplayUtil.showMessageToast('There is no program under this company. Please choose different company',
                                this.platform, this.toastCtl, 3000, "bottom");
                            return false;
                        } else this.goSelectThis(discountCompany);
                    } else {
                        MessageDisplayUtil.showMessageToast('There is no program under this company. Please choose different company',
                            this.platform, this.toastCtl, 3000, "bottom");
                        return false;
                    }
                })
        }
        // if(_discComp.discountPrograms && _discComp.discountPrograms.length === 0 || !_discComp.discountPrograms) {
        //     MessageDisplayUtil.showMessageToast('There is no program under this company. Please choose different company',
        //     this.platform , this.toastCtl,3000, "bottom");
        //     return false;
        // }

    }
    goSelectThis(discountCompany: DiscountCompany) {


        this.modalCtrl.dismiss(({
            selected: true,
            discCompany: discountCompany,
        }))
    }
    selectHole(hole: CourseHoleInfo, whichNine: number) {
        this.modalCtrl.dismiss({
            hole: hole,
            whichNine: whichNine
        });
    }

    getTeeTimeBookingList() {
        let _clubCourseId;
        this.startCourses = []
        // let _courseId;
        // _courseId = this.courseId;
        _clubCourseId = this.isClub ? this.clubId : this.courseId
        this.flightService.getTeeTimeSlot(this.forDate, this.isClub, _clubCourseId)
            .subscribe((data: Array<TeeTimeSlotDisplay>) => {
                this.teeSlot = data;
                if (this.changeType === 'course') {
                    this.teeSlot = this.teeSlot.filter((tee: TeeTimeSlotDisplay) => {
                        return tee.slot.teeOffTime === this.currentSlot.slotAssigned.teeOffTime && tee.slot.startCourse.id !== this.currentSlot.slotAssigned.startCourse.id
                    })
                } else {
                    this.teeSlot = this.teeSlot.filter((tee: TeeTimeSlotDisplay) => {
                        return tee.slot.teeOffTime !== this.currentSlot.slotAssigned.teeOffTime
                        // && (tee.slot.teeOffDate === moment().toDate() && (moment(tee.slot.teeOffTime,'HH:mm:ss').format('HH:mm') >= moment().format('HH:mm')))
                    })
                }


                this.teeSlot.forEach((t: TeeTimeSlotDisplay) => {
                    this.startCourses.push(t.slot.startCourse);
                })

                this.startCourses = this.getUnique(this.startCourses, 'id')
                this.startCourses.sort((a, b) => {
                    if (a.displayOrder < b.displayOrder) return -1
                    if (a.displayOrder > b.displayOrder) return 1
                    else 0
                })





            })
    }

    getUnique(arr, comp) {

        // store the comparison  values in array
        const unique = arr.map(e => e[comp])

            // store the indexes of the unique objects
            .map((e, i, final) => final.indexOf(e) === i && i)

            // eliminate the false indexes & return unique objects
            .filter((e) => arr[e]).map(e => arr[e]);

        return unique;
    }


    changeSlot(slot: TeeTimeSlotDisplay, type?: string) {

        if (!slot.available && type === 'slot') return false;
        // && type === 'course'
        this.flightService.getBookingFlightList(this.clubId, moment(slot.slot.teeOffDate).format('YYYY-MM-DD'), true)
            .subscribe((data) => {

                let _flightList: Array<TeeTimeBooking>
                let _hasFlight: Array<TeeTimeBooking>;
                if (data) {
                    _flightList = data.flightList;
                    _hasFlight = _flightList.filter((t: TeeTimeBooking) => {
                        return (t.slotAssigned.slotNo === slot.slot.slotNo) && (t.slotAssigned.slotDayId === slot.slot.slotDayId)
                    })


                }
                if (_hasFlight && _hasFlight.length > 0) {


                    if (_hasFlight[0].flight && _hasFlight[0].flight.status === 'PlayFinished') {

                        MessageDisplayUtil.showMessageToast('There is Finished Flight in this slot. Please choose different slot.',
                            this.platform, this.toastCtl, 3000, "bottom");
                        return false;
                    } else {
                        this.modalCtrl.dismiss({
                            newSlot: slot,
                            currentSlot: this.currentSlot
                        });
                    }

                } else {
                    this.modalCtrl.dismiss({
                        newSlot: slot,
                        currentSlot: this.currentSlot
                    });
                }

            })
        // if(1) return false;

    }
    // changeSlot(slot: TeeTimeSlotDisplay) {

    //     if(!slot.available) return false;
    //     this.viewCtrl.dismiss({
    //         newSlot: slot,
    //         currentSlot: this.currentSlot
    //     });
    // }

    getSlotDetails(slot: TeeTimeSlotDisplay, attribute: string) {
        switch (attribute) {
            case 'time':
                let _time = moment(slot.slot.teeOffTime, 'HH:mm:ss').format('hh:mm A');
                return _time;
        }
    }

    getCurrentSlotDetails(attribute) {
        switch (attribute) {
            case 'time':
                let _time = moment(this.currentSlot.slotAssigned.teeOffTime, 'HH:mm:ss').format('hh:mm A');
                return _time;
            case 'courseName':
                let _courseName = this.currentSlot.slotAssigned.startCourse.name;
                return _courseName;
        }
    }

    getSlotClass(slot: TeeTimeSlotDisplay) {
        // if(slot.available) this.color = 'danger';
        // else this.color = 'primary'

        if (this.changeType === 'course') return 'slot-available'
        else {
            // return this.color
            if (slot.available) return 'slot-available';
            else return 'slot-not-available'
        }
    }

    setOptionType(type: number) {
        if (type === 1) {
            this.optionTypes = 'types';
            // this.friendScreenName = 'Search';
            // if (this.platform.is("ios") && this.platform.is("capacitor")) {
            //     this.keyboard.close();
            // }
        }
        if (type === 2) {
            this.optionTypes = 'discount';
            // this.friendScreenName = 'My Bookings';
            // this._refreshRequest(null, null);
            // this.refreshActiveBooking();
            // if (this.platform.is("ios") && this.platform.is("capacitor")) {
            //     this.keyboard.close();
            // }
        }
        if (type === 3) {
            this.optionTypes = 'voucher';
        }

    }


    onSearchCompanyClick() {
        this.discountCompanies = [];
        let _search = '';
        if (this.searchCompany) _search = this.searchCompany;

        if (this.partnerType === 'insurance')
            this.goSearchInsuranceCompany();
        else if (this.partnerType === 'discount')
            this.goSearchCompany();
        else this.goSearchCompany();
        // this.flightService.getDiscountCompanies(_search)
        //     .subscribe((data: any) => {

        //         if (data && data.success) {
        //             this.discountCompanies = data.items;
        //         }
        //     })
    }
    ionViewWillEnter() {

        if (this.partnerType === 'insurance')
            this.goSearchInsuranceCompany();
        else if (this.partnerType === 'discount')
            this.goSearchCompany();
        else this.goSearchCompany();
    }
    goSearchCompany() {
        this.discountCompanies = [];
        let _params = {};
        if (this.searchCompany) _params['search'] = this.searchCompany;
        _params['partnerServices'] = [];
        if (this.countryId) _params['country'] = this.countryId;
        if (this.partnerType)
            _params['partnerServices'].push(this.partnerType.toUpperCase());
        // _params['partnerServices'] = ['DISCOUNT'];
        // _params['country]']

        this.flightService.getPartnerList(_params)
            .subscribe((data) => {

                if (data && data.success) {
                    this.discountCompanies = data.items.sort((a, b) => {
                        if (a.id < b.id) return -1;
                        else if (a.id > b.id) return 1;
                        else return 0;
                    });

                    let _partnerId = this.mg2uUtil.getPartnerInfo();
                    if (_partnerId) {
                        this.discountCompanies = this.discountCompanies.filter((p) => {
                            return p.id === _partnerId;
                        })
                    }
                }
            })
        // let _search = '';
        // if(this.searchCompany) _search = this.searchCompany;
        // this.flightService.getDiscountCompanies(_search)
        // .subscribe((data)=>{

        //     if(data && data.success) {
        //         this.discountCompanies = data.items;
        //     }
        // })
    }
    goSearchInsuranceCompany() {
        this.discountCompanies = [];
        let _search = '';
        let _params = {};
        if (this.searchCompany) _params['search'] = this.searchCompany;
        _params['partnerServices'] = [];
        if (this.partnerType)
            _params['partnerServices'].push(this.partnerType.toUpperCase());
        // _params['country]']

        this.flightService.getPartnerList(_params)
            .subscribe((data) => {

                if (data && data.success) {
                    this.discountCompanies = data.items;
                }
            })
    }
    getPartnerType() {
        let _name = '';
        if (this.partnerType) _name = this.partnerType.toLowerCase();

        if (this.partnerType && this.partnerType.toLowerCase() === 'nga_membership')
            _name = 'handicap'
        return _name
    }
    getCompAddress(company: DiscountCompany) {
        let _address = '';
        let _fullAddress = [];
        if (company.address) {
            company.address.address1 ? _fullAddress.push(company.address.address1) : '';
            company.address.address2 ? _fullAddress.push(company.address.address2) : '';
            company.address.city ? _fullAddress.push(company.address.city) : '';
            company.address.state ? _fullAddress.push(company.address.state) : '';
            company.address.countryData ? _fullAddress.push(company.address.countryData.name) : '';
            _address = _fullAddress ? _fullAddress.join(',') : '';
        } else _address = null;
        return _address;

    }
    getPartnerDetails(partner: DiscountCompany, attribute?: string) {
        if (!attribute) return;
        if (!partner) return;
        let _services = [];
        if (partner.partnerServices)
            _services.push(...partner.partnerServices)
        if (_services)
            _services.forEach((s, idx, arr) => {
                if (s.toLowerCase() === 'nga_membership')
                    arr[idx] = 'National Handicap System Membership';
                else arr[idx] = s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
            })
        switch (attribute) {
            case 'services':
                return "Provides : " + _services.join(', ');
        }

    }

    async onZoomImage(image: string) {
        let imageZoom = await this.modalCtrl.create({
            component: ImageZoomPage,
cssClass: 'self-adjustable-modal',
            componentProps: {
                image: image
            }
        })

        imageZoom.onDidDismiss().then((data: any) => { });
        imageZoom.present();
    }
}
